import { render, staticRenderFns } from "./payCenter2.vue?vue&type=template&id=9a725556&scoped=true&"
import script from "./payCenter2.vue?vue&type=script&lang=js&"
export * from "./payCenter2.vue?vue&type=script&lang=js&"
import style0 from "./payCenter2.vue?vue&type=style&index=0&id=9a725556&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./payCenter2.vue?vue&type=style&index=1&id=9a725556&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a725556",
  null
  
)

export default component.exports